import {
  SET_SYNONYMOUS_TEXT,
  ADD_SYNONYMOUS_TEXT,
  REMOVE_SYNONYMOUS_TEXT,
  UPDATE_SYNONYMOUS_TEXT,
  SHOW_SYNONYMOUS_TEXT,
  LIST_SYNONYMOUS_TEXTS,

  SET_PARAPHRASE_TEXT,
  ADD_PARAPHRASE_TEXT,
  REMOVE_PARAPHRASE_TEXT,
  UPDATE_PARAPHRASE_TEXT,
  SHOW_PARAPHRASE_TEXT,
  LIST_PARAPHRASE_TEXTS,

  ADD_SPINTAX_TEXT,
  REMOVE_SPINTAX_TEXT,
  UPDATE_SPINTAX_TEXT,
  SHOW_SPINTAX_TEXT,
  LIST_SPINTAX_TEXTS
} from '../actions'

export const setSynonymousText = text => ({
  type: SET_SYNONYMOUS_TEXT,
  payload: text
})

export const addSynonymousText = text => ({
  type: ADD_SYNONYMOUS_TEXT,
  payload: text
})

export const removeSynonymousText = textID => ({
  type: REMOVE_SYNONYMOUS_TEXT,
  payload: textID
})

export const updateSynonymousText = (textID, paragraphs) => ({
  type: UPDATE_SYNONYMOUS_TEXT,
  payload: { textID, paragraphs }
})

export const showSynonymousText = textID => ({
  type: SHOW_SYNONYMOUS_TEXT,
  payload: textID
})

export const listSynonymousTexts = () => ({ type: LIST_SYNONYMOUS_TEXTS })


export const setParaphraseText = text => ({
  type: SET_PARAPHRASE_TEXT,
  payload: text
})

export const addParaphraseText = text => ({
  type: ADD_PARAPHRASE_TEXT,
  payload: text
})

export const removeParaphraseText = textID => ({
  type: REMOVE_PARAPHRASE_TEXT,
  payload: textID
})

export const updateParaphraseText = (textID, text) => ({
  type: UPDATE_PARAPHRASE_TEXT,
  payload: { textID, text }
})

export const showParaphraseText = textID => ({
  type: SHOW_PARAPHRASE_TEXT,
  payload: textID
})

export const listParaphraseTexts = () => ({ type: LIST_PARAPHRASE_TEXTS })


export const addSpintaxText = text => ({
  type: ADD_SPINTAX_TEXT,
  payload: text
})

export const removeSpintaxText = textID => ({
  type: REMOVE_SPINTAX_TEXT,
  payload: textID
})

export const updateSpintaxText = textID => ({
  type: UPDATE_SPINTAX_TEXT,
  payload: textID
})

export const showSpintaxText = textID => ({
  type: SHOW_SPINTAX_TEXT,
  payload: textID
})

export const listSpintaxTexts = () => ({ type: LIST_SPINTAX_TEXTS })
